<template>
    <div>
      <edit-label-set
        @reload="reload"
        @close_modal="edit_mode = false"
        :label_set="label_set" 
        v-if="edit_mode">
      </edit-label-set>

      <create-label-set-from-filters-modal
        @reload="reload"
        @close_modal="create_from_filters_mode = false"
        v-if="create_from_filters_mode">
      </create-label-set-from-filters-modal>

      <div>
        <h4 v-if="selectedLabelSet.length == 0">{{$t('models_and_train_configs.select_your_labelset')}}</h4>
        <h4 v-if="selectedLabelSet && selectedLabelSet.length > 0">Selected label set:</h4>
        <v-chip v-if="selectedLabelSet && selectedLabelSet.length > 0"
          close @click:close="() => unselect_label_set()">
          {{ selectedLabelSet[0].name }}
        </v-chip>
      </div>

      <div style="margin-top: 15px">
        <v-btn color="primary" @click.native="createNewLabelSet" id="load_button" class="button" style="margin-right: 10px;">
          {{$t('set_label_sets.button_create')}}
        </v-btn>
        <v-btn color="primary" @click.native="createLabelSetFromFilters" id="create_from_filters_button" class="button" style="margin-right: 10px;">
          {{$t('set_label_sets.button_create_from_filters')}}
        </v-btn>
      </div>

      <v-text-field
        :label="$t('set_label_sets.search')"
        prepend-inner-icon="mdi-magnify"
        v-model="filter" />
      <v-dialog v-model="showErrorDialog" max-width="500" persistent>
        <v-card>
          <v-toolbar color="error" dark>
            <v-icon left>mdi-alert-circle</v-icon>
            <v-toolbar-title>Auto-generate Error</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showErrorDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-6">
            <v-alert type="error" text border="left" class="mb-0">
              <div class="error-message-text">
                {{ errorDialogMessage }}
              </div>
            </v-alert>
          </v-card-text>
          <v-card-actions class="px-6 pb-4">
            <v-spacer></v-spacer>
            <v-btn color="error" depressed @click="showErrorDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-data-table
        :loading="loading"
        :items="items"
        :server-items-length="totalItems"
        :headers="headers"
        :options.sync="options"
        :single-select="true"
        :show-select = "show_select_boxes"
        v-model="selectedLabelSet"
      >
        <template v-slot:item.name="{ item }" >
          <span @click="editExistingLabelSet(item)">{{ item.name }}</span>
        </template>
        <template v-slot:item.description="{ item }">
          <span @click="editExistingLabelSet(item)">{{ item.description }}</span>
        </template>
        <template v-slot:item.created_at="{ item }">
          <span @click="editExistingLabelSet(item)">{{ item.created_at }}</span>
        </template>
        <template v-slot:item.updated_at="{ item }">
          <span @click="editExistingLabelSet(item)">{{ item.updated_at }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
                  small
                  class="mr-2"
                  @click="deleteLabelSet(item)"
          >
            far fa-trash-alt
          </v-icon>
          <v-icon
                  small
                  class="mr-2"
                  @click="copyLabelSet(item)"
          >
            far fa-copy
          </v-icon>
          <v-icon
          small
          class="mr-2"
          @click="editExistingLabelSet(item)"
        >
          mdi-pencil
        </v-icon>
        </template>
      </v-data-table>
    </div>
</template>

<script>

import ApiDatatableMixin from "@/mixins/ApiDatatableMixin";
import EditLabelSet from "@/components/EditLabelSet.vue";
import CreateLabelSetFromFiltersModal from "@/components/CreateLabelSetFromFiltersModal.vue";

  export default {
    name: "Manage",
    components: {
      EditLabelSet,
      CreateLabelSetFromFiltersModal,
    },
    props: {
      show_select_boxes: {
        type: Boolean,
        default: false,
      },
      selected_label_set_id: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        'api_model': 'label_set',
        edit_mode: false,
        create_from_filters_mode: false,
        label_set : null,
        selectedLabelSet: [],
        selectedLabelSetDetails: [],
        filterHasBeenSet: false,
        showErrorDialog: false,
        errorDialogMessage: '',
      }
    },
    mixins: [ApiDatatableMixin],
    methods: {
      createNewLabelSet() {
        this.$set(this, 'label_set', null) 
        this.$set(this, 'edit_mode', true)
      },
      createLabelSetFromFilters() {
        this.$set(this, 'create_from_filters_mode', true)
      },
      editExistingLabelSet(item) {
        this.$set(this, 'label_set', item) 
        this.$set(this, 'edit_mode', true)
      },
      async deleteLabelSet(item) {
        this.$set(this, 'loading', true);
        await this.$api.label_set.deleteLabelSet(item);
        await this.loadItems();
        this.$set(this, 'loading', false);
      },
      async reload() {
        await this.loadItems();
      },
      showLabelSetModal() {
        this.$set(this, 'edit_mode', true);
      },
      async copyLabelSet(item) {
        this.$set(this, 'loading', true);

        let originalLabelsResponse = await this.$api.label_set.getLabels(item);
        let originalLabelIds = originalLabelsResponse.map(label => label.id);

        let copiedItemName = item.name + ' Copy';
        let copiedLabelSet = { ...item, name: copiedItemName };
        let copiedLabelSetResponse = await this.$api.label_set.addLabelSet(copiedLabelSet.name, copiedLabelSet.description);
        
        await this.$api.label_set.updateLabels(copiedLabelSetResponse, originalLabelIds);
        await this.loadItems();
        this.$set(this, 'loading', false);
      },
      async autoGenerateLeaves() {
        this.$set(this, 'loading', true);
        try {
          const response = await this.$api.label_set.autoGenerateLeaves();
          
          // Check if response has an error property (API wrapper might return error in response.data)
          if (response && response.error) {
            const errorMessage = response.error;
            //const noLabelsError = 'No labels found matching the criteria (leaf labels with parent and at least 10 annotations)';
            
            if (errorMessage.includes('No labels found matching the criteria')) {
              this.errorDialogMessage = errorMessage;
              this.showErrorDialog = true;
            } else {
              await this.$store.dispatch('snackbars/add_error_snack', {
                'message': errorMessage,
              });
            }
            this.$set(this, 'loading', false);
            return;
          }
          
          // Check if response is null (API wrapper might return null on error)
          if (!response) {
            // Error was already handled by API wrapper, but we might want to show a generic message
            this.$set(this, 'loading', false);
            return;
          }
          
          await this.loadItems();
          await this.$store.dispatch('snackbars/add_success_snack', {
            'message': 'Labelset auto-generated successfully',
          });
        } catch (error) {
          const errorMessage = error.response?.data?.error || error.message || 'Failed to auto-generate labelset';
          //const noLabelsError = 'No labels found matching the criteria (leaf labels with parent and at least 10 annotations)';
          
          if (errorMessage.includes('No labels found matching the criteria')) {
            this.errorDialogMessage = errorMessage;
            this.showErrorDialog = true;
          } else {
            await this.$store.dispatch('snackbars/add_error_snack', {
              'message': errorMessage,
            });
          }
        }
        this.$set(this, 'loading', false);
      },
      unselect_label_set() {
          this.$set(this, 'selectedLabelSet', [])
          this.$set(this, 'selected_label_set_id', null);
          this.$set(this, 'filter', '')
          this.$set(this, 'filterHasBeenSet', false);
      },
      async loadSelectedLabelSetDetails() {
        if (this.selected_label_set_id) {
          this.selectedLabelSetDetails = await this.$api.label_set.getLabelSet(this.selected_label_set_id); 
          this.$set(this, 'selectedLabelSet', [this.selectedLabelSetDetails]);
          if (!this.filterHasBeenSet) {
              this.$set(this, 'filter', this.selectedLabelSetDetails.name);
              this.$set(this, 'filterHasBeenSet', true);
          }
        }
      },
    },
    watch: {
      selectedLabelSet(newValue) {
        if (newValue && newValue.length > 0) {
            this.$emit("selected_label_set_id", newValue[0].id);
            if (!this.filterHasBeenSet) {
                this.filter = newValue[0].name;
                this.filterHasBeenSet = true;
            }
        } else {
            this.$emit("selected_label_set_id", null);
            this.filter = '';
            this.filterHasBeenSet = false;
        }
      },
      items(newItems) {
        if (this.selected_label_set_id && newItems.length > 0) {
          let selected_label_set = newItems.find(item => item.id === this.selected_label_set_id);
          if (selected_label_set) {
            this.selectedLabelSet = [selected_label_set];
          }
        }
      }
    },
    mounted() {
      this.loadSelectedLabelSetDetails();
    },
    computed: {
      headers(){
        return [
        {text: this.$t('set_label_sets.name'), value: 'name'},
        {text: this.$t('set_label_sets.description'), value: 'description'},
        {text: this.$t('set_label_sets.created_at'), value: 'created_at'},
        {text: this.$t('set_label_sets.updated_at'), value: 'updated_at'},
        {text: this.$t('set_label_sets.actions'), value: 'actions' },
        ]
      }
    },
  }
</script>

<style scoped>
.error-message-text {
  font-size: 15px;
  line-height: 1.6;
  word-wrap: break-word;
}
</style>